export const DOCUMENT_STATUS_ALL = "all";

export function filterDocuments(documents, filters = {}) {
  const query = normalizeSearchQuery(filters.query);
  const status = normalizeStatusFilter(filters.status);

  return documents.filter((document) => {
    if (status !== DOCUMENT_STATUS_ALL && documentStatus(document) !== status) {
      return false;
    }

    if (!query) {
      return true;
    }

    return searchableDocumentText(document).includes(query);
  });
}

export function documentStatus(document) {
  return document.status || "registered";
}

export function documentProcessingSummary(document) {
  const errorMessage = String(document.import_error_message || "").trim();
  return {
    versionLabel: document.current_version_label || "v1",
    versionId: document.current_version_id || "",
    status: documentStatus(document),
    mediaType: document.media_type || "application/octet-stream",
    byteSize: document.byte_size || 0,
    chunkCount: document.chunk_count || 0,
    contentHash: document.content_hash || "",
    hasImportError: Boolean(errorMessage),
    errorMessage,
    importStage: normalizeImportStage(document.import_stage),
  };
}

export function documentProcessingSteps(document) {
  const summary = documentProcessingSummary(document);
  const failed = summary.status === "failed";
  const processing = summary.status === "processing";
  const completed = summary.status === "completed";
  const hasVersion = Boolean(summary.versionId);
  const stageIndex = importStageIndex(summary.importStage);

  const steps = [
    {
      key: "upload",
      label: "Сохранение оригинала",
      description: "Сохраняем исходный документ в S3",
      state: hasVersion ? "completed" : "waiting",
    },
    {
      key: "parse",
      label: "Извлечение текста",
      description: "Извлекаем текст из исходного формата документа",
      state: processingStepState(1, stageIndex, processing, completed, failed),
    },
    {
      key: "normalize",
      label: "Нормализация",
      description: "Приводим текст к нормализованной JSON-модели",
      state: processingStepState(2, stageIndex, processing, completed, failed),
    },
    {
      key: "chunk",
      label: "Деление на фрагменты",
      description: "Нарезаем документ на фрагменты для поиска",
      state: processingStepState(3, stageIndex, processing, completed, failed),
    },
    {
      key: "index",
      label: "Индексирование",
      description: "Строим связи между фрагментами",
      state: processingStepState(4, stageIndex, processing, completed, failed),
    },
  ];

  if (failed) {
    const failedIndex = Math.max(1, stageIndex);
    steps.forEach((step, index) => {
      if (index < failedIndex) step.state = "completed";
      if (index === failedIndex) step.state = "failed";
      if (index > failedIndex) step.state = "waiting";
    });
  }

  return steps;
}

const IMPORT_STAGES = ["source_stored", "text_extraction", "normalization", "chunking", "indexing", "completed"];

function normalizeImportStage(value) {
  const stage = String(value || "source_stored");
  return IMPORT_STAGES.includes(stage) ? stage : "source_stored";
}

function importStageIndex(stage) {
  if (stage === "completed") return 5;
  return Math.max(0, IMPORT_STAGES.indexOf(stage));
}

function processingStepState(stepIndex, stageIndex, processing, completed, failed) {
  if (completed) return "completed";
  if (failed) return "waiting";
  if (stepIndex < stageIndex) return "completed";
  if (processing && stepIndex === stageIndex) return "active";
  return "waiting";
}

export function documentCanRunRetrieval(document) {
  const summary = documentProcessingSummary(document);
  return summary.status === "completed" && summary.chunkCount > 0;
}

function normalizeSearchQuery(value) {
  return String(value || "")
    .trim()
    .toLocaleLowerCase("ru-RU");
}

function normalizeStatusFilter(value) {
  const status = String(value || DOCUMENT_STATUS_ALL).trim();
  return status || DOCUMENT_STATUS_ALL;
}

function searchableDocumentText(document) {
  return [
    document.title,
    document.media_type,
    document.current_version_label,
    document.content_hash,
    document.import_error_message,
  ]
    .filter(Boolean)
    .join(" ")
    .toLocaleLowerCase("ru-RU");
}
